/**
 * Script para formatação automática de campos de telefone e WhatsApp
 * 
 * Este script aplica máscaras aos campos de telefone e WhatsApp das filiais ou qualquer outro que tiver
 * a classe phone-mask para que o usuário só precise digitar os números.
 */

(function($) {
    'use strict';
    
    function applyPhoneMask(input) {
        let value = input.value.replace(/\D/g, '');
        
        // Limita a 11 dígitos (DDD + 9 dígitos)
        if (value.length > 11) {
            value = value.slice(0, 11);
        }
        
        if (value.length <= 2) {
            // Apenas DDD
            input.value = value.length > 0 ? '(' + value : '';
        } else if (value.length <= 7) {
            // DDD + primeiros dígitos
            input.value = '(' + value.substring(0, 2) + ') ' + value.substring(2);
        } else if (value.length <= 11) {
            // Formato completo
            // Se for celular (9 dígitos após DDD)
            if (value.length > 10) {
                input.value = '(' + value.substring(0, 2) + ') ' + 
                              value.substring(2, 7) + '-' + 
                              value.substring(7);
            } else {
                // Se for telefone fixo (8 dígitos após DDD)
                input.value = '(' + value.substring(0, 2) + ') ' + 
                              value.substring(2, 6) + '-' + 
                              value.substring(6);
            }
        }
    }
    
    // Aplica a máscara quando o DOM estiver pronto
    $(document).ready(function() {
        applyPhoneMasks();
        // Para campos adicionados dinamicamente (como em grupos repetíveis do CMB2)
        $(document).on('cmb2_add_row', applyPhoneMasks);
    });
    
    function applyPhoneMasks() {
        const phoneFields = document.querySelectorAll('.phone-mask');
        
        phoneFields.forEach(function(field) {
            field.removeEventListener('input', function() {
                applyPhoneMask(field);
            });
            
            field.addEventListener('input', function() {
                applyPhoneMask(this);
            });
            
            if (field.value) {
                applyPhoneMask(field);
            }
        });
    }
    
})(jQuery);
